export default __webpack_public_path__ + "static/media/scroll.eb40f0b8.png";